/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Steps_TitleInputs */

const en_svc_integration_steps_title = /** @type {(inputs: Svc_Integration_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How we integrate AI.`)
};

const lv_svc_integration_steps_title = /** @type {(inputs: Svc_Integration_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā mēs integrējam AI.`)
};

/**
* | output |
* | --- |
* | "How we integrate AI." |
*
* @param {Svc_Integration_Steps_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_steps_title = /** @type {((inputs?: Svc_Integration_Steps_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Steps_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_steps_title(inputs)
	return en_svc_integration_steps_title(inputs)
});